import styles from "./CartItem.module.css";
import noImg from "../../../../assets/tempIMG1.jpg";
import { useState } from "react";
import X from "../../../../assets/x-highlight.png";

export default function CartItem({ item, cartCtx }) {
  const [quantity, setQuantity] = useState(item.quantity);

  const onIncreaseHandler = () => {
    cartCtx.addItem([item]);
    setQuantity((prevVal) => prevVal + 1);
  };

  const onDecreaseHandler = () => {
    cartCtx.removeItem(item.id, false);
    setQuantity((prevVal) => prevVal - 1);
  };

  const onRemoveHandler = () => {
    cartCtx.removeItem(item.id, true);
  };

  const quantityChangeHandler = (e) => {
    const value = e.target.value;

    if (value !== "") {
      if (value > item.quantity) {
        for (let i = item.quantity; i < value; i++) {
          onIncreaseHandler();
        }
      } else if (value < item.quantity) {
        for (let i = value; i < item.quantity; i++) {
          onDecreaseHandler();
        }
      }
    }

    setQuantity(value);
  };

  const onFocusOut = (e) => {
    const value = e.target.value;

    if (value === "") {
      setQuantity(item.quantity);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.info}>
        <img className={styles.image} src={item?.images?.[0]?.src || noImg} />
      </div>

      <div className={styles[`main-info`]}>
        <div className={styles.title}>{item.name}</div>

        <div className={styles.quantity}>
          <div
            className={`${styles.action} ${
              styles[item.stock_quantity === null && `action-disabled`]
            }`}
            onClick={
              item.stock_quantity === null ? () => {} : onDecreaseHandler
            }
          >
            -
          </div>

          <input
            className={styles.count}
            value={quantity}
            min={1}
            type="number"
            onChange={quantityChangeHandler}
            onBlur={onFocusOut}
          />
          <div
            className={`${styles.action} ${
              styles[quantity >= item.stock_quantity && `action-disabled`]
            }`}
            value={1}
            onClick={
              quantity >= item.stock_quantity ? () => {} : onIncreaseHandler
            }
          >
            +
          </div>
        </div>
      </div>
      <div className={styles[`remove-container`]} onClick={onRemoveHandler}>
        <img className={styles[`remove-image`]} src={X} alt="X" />
      </div>
    </div>
  );
}
